import { useTranslation } from 'react-i18next'
import { useSubmitLeadMutation } from '../../api/apiSlice'
import * as yup from 'yup'
import { Controller, useForm, useFormState } from 'react-hook-form'
import { Box, Checkbox, FormControlLabel, Stack, Typography } from '@mui/material'
import React from 'react'
import { AgreementDefinition, Lead } from '../../api/interfaces'
import DOMPurify from 'dompurify'
import { yupResolver } from '@hookform/resolvers/yup'
import Button from '@mui/material/Button'
import { lang } from '../../../dom'
import { useAppSelector } from '../../../app/hooks'

export const Success = () => {
    const { t } = useTranslation()

    return <>
        <Typography mb={4} variant="h5" component="h1">{t('Success.heading')}</Typography>

        <Typography mb={2} variant="body1">{t('Success.text1')}</Typography>
        <Typography variant="body1">{t('Success.text2')}</Typography>
    </>
}
